/**
 * MForm 에서 폼 구성요소를 구분하기 위한 정의입니다.
 */
export const FORM_TABLE_TYPE = {
    TEXT: 'TEXT',
    TEXTAREA: 'TEXTAREA',
};
